// extracted by mini-css-extract-plugin
export default {"home_fettier":"style_home_fettier__yJGYL","home_fettier_left":"style_home_fettier_left__N4U2i","home_fettier_right":"style_home_fettier_right__6e3to"};